import { Component } from '@angular/core';

@Component({
  selector: 'app-message-info',
  templateUrl: './message-info.component.html'
})
export class MessageInfoComponent {

  setMsgList(msgList: Array<string>) {
    let message = '';
    for (var i = 0; i < msgList.length; i++) {
      if (i === msgList.length - 1) {
        message = message + msgList[i];
      } else {
        message = message + msgList[i] + '\n';
      }
    }
    document.getElementById('msgDiv').innerText = message;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  setMsg(msg: string) {
    document.getElementById('msgDiv').innerText = msg;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  setMsgListNoTopScroll(msgList: Array<string>) {
    let message = '';
    for (var i = 0; i < msgList.length; i++) {
      if (i === msgList.length - 1) {
        message = message + msgList[i];
      } else {
        message = message + msgList[i] + '\n';
      }
    }
    document.getElementById('msgDiv').innerText = message;
  }
  setMsgNoTopScroll(msg: string) {
    document.getElementById('msgDiv').innerText = msg;
  }

  clearMsg() {
    document.getElementById('msgDiv').innerText = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/message-info/message-info.component.ts